var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-info",on:{"click":function($event){$event.preventDefault();return _vm.userDetailsReport.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('reports')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }